const defaultEmailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const nameRegex = /^\p{L}+(?:[-']\p{L}+)*$/u;
const nameCharactersRegex = /^[\p{L}'-]*$/u;
const emailCharactersRegex = /^[a-zA-Z0-9._+@-]*$/;

export const isValidName = (name: string): boolean => nameRegex.test(name);
export const hasValidNameCharacters = (name: string): boolean => nameCharactersRegex.test(name);
export const hasValidEmailCharacters = (email: string): boolean => emailCharactersRegex.test(email);

export const isValidEmail = (email: string, emailPattern: RegExp = defaultEmailRegex): boolean => {
  return emailPattern.test(email);
};

export const isValidBusinessEmail = (
  email: string,
  organizationDomains: string | null = null,
  emailPattern: RegExp = defaultEmailRegex
): boolean => {
  if (!organizationDomains || !organizationDomains.length) {
    return isValidEmail(email, emailPattern);
  }
  if (isValidEmail(email, emailPattern)) {
    const [, domain] = email.split('@');
    const allowedDomains = organizationDomains.split(',');
    return allowedDomains.includes(domain);
  }
  return false;
};

export const isValidPhoneNumber = (
  phoneNumber: string,
  onlyUnitedStatesNumber = false
): boolean => {
  return onlyUnitedStatesNumber
    ? /^(1 )?[2-9]\d{2}-\d{3}-\d{4}$/.test(phoneNumber)
    : /^(\d{1,3}\s)?\d{3}-\d{3}-\d{4}$/.test(phoneNumber);
};
